type PerfMetricWithComparison = {
  currentValue: number,
  percentShift?: number,
  impact?: string,
};

// https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCommon%2FShared.Plugin%2FShared.Plugin%2FModels%2FSummarizeCampaignResponse.cs
export type SummarizeCampaignResponse = {
  accountCurrency?: string;

  impressionCount?: number;
  clickCount?: number;
  ctr?: number;
  spend?: number;
  conversionCount?: number;
  cpa?: number;
  roas?: number;
  averageCPC?: number;
  averageCPM?: number;
  impressionShare?: number;
  uniqueReach?: number;
  // Missing: Audience Campaign - Average Impression frequency per user
  averageCPV?: number;
  videoViews?: number;
  videoCompletionRate?: number;
  videoViewsAt25Percent?: number;
  videoViewsAt50Percent?: number;
  videoViewsAt75Percent?: number;
  installs?: number;
  downloads?: number;
  averageCPI?: number;

  perfMetricsWithComparisonData?: {
    conversions?: PerfMetricWithComparison;
    clicks?: PerfMetricWithComparison;
    impressions?: PerfMetricWithComparison;
    spend?: PerfMetricWithComparison;
    ctr?: PerfMetricWithComparison;
    averageCPC?: PerfMetricWithComparison;
    cpa?: PerfMetricWithComparison;
    roas?: PerfMetricWithComparison;
    averageCPM?: PerfMetricWithComparison;
    impressionShare?: PerfMetricWithComparison;
    uniqueReach?: PerfMetricWithComparison;
    averageCPV?: PerfMetricWithComparison;
    videoViews?: PerfMetricWithComparison;
    videoCompletionRate?: PerfMetricWithComparison;
    videoViewsAt25Percent?: PerfMetricWithComparison;
    videoViewsAt50Percent?: PerfMetricWithComparison;
    videoViewsAt75Percent?: PerfMetricWithComparison;
    installs?: PerfMetricWithComparison;
    downloads?: PerfMetricWithComparison;
    averageCPI?: PerfMetricWithComparison;
  }

  comparisonStartDate?:string,
  comparisonEndDate?:string,
  startDate?:string,
  endDate?:string,
};

export type SummarizePluginResult = {
  Result?: SummarizeCampaignResponse;
  Parameters?: {
    CampaignName?: string;
    StartDate?: string;
    EndDate?: string;
  };
};

export const matchingMetricTypes = {
  Impression: 'Impressions',
  Click: 'Clicks',
  Conversion: 'Conversions',
};

export type MetricTypes = 'Conversions' | 'Impressions' | 'Clicks';
export type MetricTypesSingular = 'Conversion' | 'Impression' | 'Click';
export type ShiftDirectionTypes = 'Increase' | 'Decrease';

export type Fluctuation = {
  accountId: number;
  campaignId?: number;
  metricType: MetricTypesSingular;
  shiftStartDate: string;
  shiftEndDate: string;
  shiftSummary: string;
  shiftDirection: ShiftDirectionTypes;
};

export type Parameters = {
  CampaignName?: string,
  Granularity?: string,
  StartDate?: string,
  EndDate?: string,
};

export type PluginResult = {
  Name: string;
  Status: string;
  Parameters?: Parameters;
};

export type FluctuationResult = PluginResult & {
  Result?: Fluctuation[] | { Type: string, Title: string, Status: number };
};

export interface IDataPoint {
  DateTime: string;
  Value: number;
  Fluctuate?: boolean;
}

export type IPerformanceTimeSeries = {
  UniqueId: string;
  MetricName: MetricTypes;
  DataPoints: IDataPoint[];
};

export type PerformanceTimeSeriesResult = PluginResult & {
  Result?: {
    metricName: string;
    metricValue: {
      dateTime: string;
      value: number;
    }[];
  }[];
};
